<template>
  <CustomCollapse id="peiTab3Collapse" class="m-0 mt-n3">
    <CustomCollapseItem
      id="conductaInapropiadaItem"
      parent-id="peiTab3Collapse"
      title="Añadir Conducta Inapropiada"
      :expanded="accordionItems.conducts.expanded"
      :checked="accordionItems.conducts.checked"
      :selected="accordionItems.conducts.selected"
      :disabled="accordionItems.conducts.disabled"
      @toggleCollapse="
        accordionItems.conducts.expanded = !accordionItems.conducts.expanded
      "
    >
      <span
        v-if="isEditionMode"
        slot="extraHeaderContent"
        class="font-weight-normal custom-mr"
      >
        <b>Selección:</b>
        {{ conductSelected?.title }}
      </span>
      <div class="card-body">
        <MultiSelectionPicker
          :all-items="functionConducts"
          :selected-items="selectedConducts"
          item-type-name="Conducta"
          :allow-item-list-editing="true"
          :modify-removes-item="false"
          :column-count="1"
          @itemDeleted="deleteConduct"
          @itemAdded="addConduct"
          @itemModified="editConduct"
          @itemSelected="updateConductChips"
        />
        <CustomChipsGroup
          :title="'Conducta Inapropiada seleccionada'"
          :selected-items="selectedConducts"
          :no-wrap="true"
          :object-text="'name'"
          @itemMarkedForDeletion="unselectConduct(item)"
        />
        <Error
          v-if="hasConductError"
          variant="no-border"
          message="Para continuar favor de seleccionar una(1) conducta inapropiada."
        />
        <div class="d-flex justify-content-end">
          <ActionButton
            type="button"
            text="Continuar"
            variant="success"
            @click="tryMoveToStrategyCollapse"
          />
        </div>
      </div>
    </CustomCollapseItem>
    <CustomCollapseItem
      id="estrategiaItem"
      parent-id="peiTab3Collapse"
      title="Añadir Estrategia"
      :expanded="accordionItems.strategies.expanded"
      :disabled="accordionItems.strategies.disabled"
      :selected="accordionItems.strategies.selected"
      :checked="accordionItems.strategies.checked"
      :error="hasPeiStrategiesError"
      :custom-error-msg="resources['R03200120']"
      @toggleCollapse="
        accordionItems.strategies.expanded = !accordionItems.strategies.expanded
      "
    >
      <div class="card-body">
        <div class="panel-body">
          <MultiSelectionPicker
            :all-items="functionStrategies"
            :selected-items="selectedItems"
            item-type-name="Estrategia"
            :allow-item-list-editing="true"
            :modify-removes-item="false"
            :column-count="1"
            @itemDeleted="deleteStrategy"
            @itemAdded="addStrategy"
            @itemModified="editStrategy"
          />
          <CustomChipsGroup
            :title="'Estrategias seleccionadas'"
            :selected-items="selectedItems"
            :no-wrap="true"
            :object-text="'name'"
            @itemMarkedForDeletion="unselectStrategy(item)"
          />
          <Error
            v-if="hasStrategyError"
            variant="no-border"
            message="Para continuar, favor de seleccionar las estrategias."
          />
          <div class="d-flex justify-content-end">
            <ActionButton
              type="button"
              text="Continuar"
              variant="success"
              @click="tryMoveToCollaborationCollapse"
            />
          </div>
        </div>
      </div>
    </CustomCollapseItem>
    <CustomCollapseItem
      id="colaboracionFamiliarItem"
      ref="colaborationStep"
      parent-id="peiTab3Collapse"
      title="Añadir Colaboración Familiar"
      :expanded="accordionItems.collaborations.expanded"
      :disabled="accordionItems.collaborations.disabled"
      :selected="accordionItems.collaborations.selected"
      :checked="accordionItems.collaborations.checked"
      :error="hasPeiCollaborationError"
      :custom-error-msg="resources['R03200121']"
      @toggleCollapse="
        accordionItems.collaborations.expanded = !accordionItems.collaborations
          .expanded
      "
    >
      <div class="card-body">
        <div class="panel-body">
          <MultiSelectionPicker
            :all-items="functionFamilies"
            :selected-items="selectedFunctionFamilies"
            item-type-name="Colaboración Familiar"
            :allow-item-list-editing="true"
            :modify-removes-item="false"
            :column-count="1"
            @itemDeleted="deleteCollaboration"
            @itemAdded="addCollaboration"
            @itemModified="editCollaboration"
          />
          <CustomChipsGroup
            :title="'Colaboraciones Familiares seleccionadas'"
            :no-wrap="true"
            :selected-items="selectedFunctionFamilies"
            :object-text="'name'"
            @itemMarkedForDeletion="unselectCollaboration(item)"
          />
          <Error
            v-if="hasCollaborationError"
            variant="no-border"
            message="Para continuar favor de seleccionar una(1) conducta inapropiada."
          />
          <div class="d-flex justify-content-end">
            <ActionButton
              type="button"
              text="Continuar y Guardar"
              variant="success"
              @click="tryEndAndSave"
            />
          </div>
        </div>
      </div>
    </CustomCollapseItem>
    <template #footer>
      <div class="custom-collapse-footer">
        <ActionButton
          type="button"
          text="Cancelar"
          i="fa fa-times-circle"
          variant="outline-danger"
          @click="$emit('cancel')"
        />
      </div>
    </template>
  </CustomCollapse>
</template>

<script>
import MultiSelectionPicker from '@/components/common/MultiSelectionPicker';
import CustomChipsGroup from '@/components/common/CustomChipsGroup';
import CustomCollapseItem from './CustomCollapseItem';
import CustomCollapse from '@/components/common/CustomCollapse';
import store from '@/store/index';
import alert from '@/mixin/alert.mixin';
import ActionButton from 'ActionButton';
import Error from '@/components/common/Error.vue';

export default {
  mixins: [alert],
  name: 'InappropriateBehaviorManagerV1',
  components: {
    Error,
    ActionButton,
    CustomCollapse,
    CustomCollapseItem,
    MultiSelectionPicker,
    CustomChipsGroup,
  },
  props: {
    peiId: {
      type: String,
      required: true,
      default: '',
    },
    resources: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      conductSelected: null,
      //CONDUCTA
      functionConducts: [],
      selectedConducts: [],
      //ESTRATEGIA
      functionStrategies: [],
      selectedItems: [],
      //COLABORACION
      functionFamilies: [],
      selectedFunctionFamilies: [],
      accordionItems: {
        conducts: {
          checked: false,
          expanded: true,
          selected: true,
          disabled: false,
          validated: false,
        },
        strategies: {
          checked: false,
          expanded: false,
          selected: false,
          disabled: true,
          validated: false,
        },
        collaborations: {
          checked: false,
          expanded: false,
          selected: false,
          disabled: true,
          validated: false,
        },
      },
    };
  },
  computed: {
    isEditionMode() {
      return (
        !!this.conductSelected?.title && this.conductSelected?.title?.length > 0
      );
    },
    hasConductError() {
      return (
        this.accordionItems.conducts.validated &&
        this.selectedConducts.length <= 0
      );
    },
    hasStrategyError() {
      return (
        this.accordionItems.strategies.validated &&
        this.selectedItems.length <= 0
      );
    },
    hasCollaborationError() {
      return (
        this.accordionItems.collaborations.validated &&
        this.selectedFunctionFamilies.length <= 0
      );
    },
    hasPeiStrategiesError() {
      return (
        store.getters.getPeiValidationTriggered.validation &&
        this.conductSelected != null &&
        this.selectedItems.length <= 0
      );
    },
    hasPeiCollaborationError() {
      return (
        store.getters.getPeiValidationTriggered.validation &&
        this.selectedItems.length > 0 &&
        this.selectedFunctionFamilies.length <= 0
      );
    },
  },
  methods: {
    async fetchData() {
      if (this.conductSelected === undefined || this.conductSelected === null)
        return;

      const res = await this.$ApiGet(
        `/api/pei/getAllpeifunctionfamily?peiFunctionConductId=${this.conductSelected.id}`
      );
      this.functionFamilies = res.data;

      const res2 = await this.$ApiGet(
        `/api/pei/GetSelectedPeiFunctionFamily?peiId=${this.peiId}&peiFunctionConductId=${this.conductSelected.id}`
      );
      this.selectedFunctionFamilies = res2.data;

      const res3 = await this.$ApiGet(
        `/api/pei/getallpeifunctionstrategy?peiFunctionConductId=${this.conductSelected.id}`
      );
      this.functionStrategies = res3.data;

      const res4 = await this.$ApiGet(
        `/api/pei/getselectedpeifunctionstrategy?peiId=${this.peiId}&peiFunctionConductId=${this.conductSelected.id}`
      );
      this.selectedItems = res4.data;
    },
    async getConducts() {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet(`/api/pei/peiFunctionConduct?peiId=${this.peiId}`)
          .then((res) => {
            self.conductsList = res.data.sort();
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    async setEditConductSelected(conduct) {
      this.conductSelected = {
        title: conduct.spaLongDescription,
        name: conduct.peiFunctionConductId,
        id: conduct.peiFunctionConductId,
      };

      await this.fetchData();

      // Estado inicial de secciones
      this.accordionItems.conducts = {
        checked: true,
        selected: false,
        expanded: false,
        disabled: true,
      };

      this.accordionItems.strategies = {
        checked: false,
        selected: true,
        expanded: true,
        disabled: false,
      };

      this.accordionItems.collaborations = {
        checked: true,
        selected: false,
        expanded: false,
        disabled: false,
      };
    },
    async getConducts() {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet(`/api/pei/peiFunctionConduct?peiId=${this.peiId}`)
          .then((res) => {
            self.functionConducts = res.data.sort();
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    //CONDUCT
    async deleteConduct(item) {
      let response = await alert.methods.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar la conducta seleccionada?',
        'Aceptar',
        'Cancelar'
      );

      if (!response) return;

      try {
        await this.$ApiGet(
          `/api/pei/DeletePeiFunctionConduct?peiFunctionConductId=${item.id}`
        );

        this.functionConducts.splice(
          this.functionConducts.findIndex((x) => x.id === item.id),
          1
        );

        // Collapse state change.
        this.accordionItems.conducts.checked = false;
        this.accordionItems.conducts.selected = true;

        this.ShowToast(
          this.resources['R03200110'],
          this.resources['R03200109'],
          'success'
        );
      } catch (err) {
        this.ShowToast(err, this.resources['R03200108'], 'error');
      }
    },
    async addConduct(text) {
      const conductDTO = {
        Name: text,
        Id: 0,
      };

      if (text.length > 2000) {
        this.ShowToast(
          'Error',
          this.resources['US111902'].replace('{0}', '2000'),
          'error'
        );
        return;
      }

      try {
        const { data } = await this.$ApiPost(
          `/api/pei/peiFunctionConductPost`,
          conductDTO
        );
        this.functionConducts.push(data);

        this.ShowToast(
          this.resources['R03200110'],
          this.resources['R03200109'],
          'success'
        );
      } catch (err) {
        this.ShowToast('Error', err.response.data.errors.errors[0], 'error');
      }
    },
    async editConduct(item, index) {
      try {
        const { data } = await this.$ApiPost(
          `/api/pei/EditPeiFunctionConduct`,
          item
        );

        this.functionConducts.splice(index, 1, data);

        this.ShowToast(
          this.resources['R03200110'],
          this.resources['R03200109'],
          'success'
        );
      } catch (err) {
        this.ShowToast(err, this.resources['R03200108'], 'error');
      }
    },
    updateConductChips(item) {
      this.selectedConducts = [item];
    },
    async unselectConduct(item) {
      let response = await alert.methods.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar la conducta seleccionada?',
        'Si',
        'No'
      );

      if (!response) return;

      this.selectedConducts.splice(this.selectedConducts.indexOf(item), 1);

      // Collapse state change.
      this.accordionItems.conducts.checked = false;
      this.accordionItems.conducts.selected = true;
      this.accordionItems.strategies.checked = false;
      this.accordionItems.strategies.selected = false;
      this.accordionItems.strategies.expanded = false;
      this.accordionItems.strategies.disabled = true;
      this.accordionItems.strategies.checked = false;
      this.accordionItems.collaborations.selected = false;
      this.accordionItems.collaborations.expanded = false;
      this.accordionItems.collaborations.disabled = true;

      this.selectedItems = [];
      this.selectedFunctionFamilies = [];
    },
    async tryMoveToStrategyCollapse() {
      this.accordionItems.conducts.validated = true;
      if (this.hasConductError) {
        return;
      }

      this.conductSelected = this.selectedConducts[0];
      await this.fetchData();

      // Collapse state change.
      this.accordionItems.conducts.checked = true;
      this.accordionItems.conducts.expanded = false;
      this.accordionItems.strategies.selected = true;
      this.accordionItems.strategies.expanded = true;
      this.accordionItems.strategies.disabled = false;
    },
    //STRATEGY
    async deleteStrategy(item) {
      let response = await alert.methods.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar la estrategia seleccionada?',
        'Aceptar',
        'Cancelar'
      );

      if (!response) return;

      try {
        await this.$ApiPost(
          `/api/pei/DeletePeiFunctionStrategy?peiFunctionConductId=${this.conductSelected.id}`,
          item
        );

        this.functionStrategies.splice(
          this.functionStrategies.findIndex((x) => x.id === item.id),
          1
        );

        // Collapse state change.
        this.accordionItems.strategies.checked = false;
        this.accordionItems.strategies.selected = true;

        this.ShowToast(
          this.resources['R03200110'],
          this.resources['R03200109'],
          'success'
        );
      } catch (err) {
        this.ShowToast(err, this.resources['R03200108'], 'error');
      }
    },
    async addStrategy(text) {
      if (text.length > 2000) {
        this.ShowToast(
          'Error',
          this.resources['US111902'].replace('{0}', '2000'),
          'error'
        );

        return;
      }

      try {
        const res = await this.$ApiPost(
          `/api/pei/AddPeiFunctionStrategy?peiFunctionConductId=${this.conductSelected.id}`,
          { name: text }
        );

        this.functionStrategies.push(res.data);
        this.ShowToast(
          this.resources['R03200110'],
          this.resources['R03200109'],
          'success'
        );
      } catch (err) {
        const error = err?.message;
        this.ShowToast('Error', error, 'error');
      }
    },
    async editStrategy(item, index) {
      try {
        const res = await this.$ApiPost(
          `/api/pei/EditPeiFunctionStrategy?peiFunctionConductId=${this.conductSelected.id}`,
          item
        );
        this.functionStrategies.splice(index, 1, res.data);

        this.ShowToast(
          this.resources['R03200110'],
          this.resources['R03200109'],
          'success'
        );
      } catch (err) {
        this.ShowToast(err, this.resources['R03200108'], 'error');
      }
    },
    async unselectStrategy(item) {
      let response = await alert.methods.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar la estrategia seleccionada?',
        'Si',
        'No'
      );
      if (!response) return;

      this.selectedItems.splice(this.selectedItems.indexOf(item), 1);

      // Collapse state change.
      this.accordionItems.strategies.checked = false;
      this.accordionItems.strategies.selected = true;
      this.accordionItems.collaborations.selected = false;
      this.accordionItems.collaborations.expanded = false;
      this.accordionItems.collaborations.disabled = true;
    },
    tryMoveToCollaborationCollapse() {
      this.accordionItems.strategies.validated = true;

      if (this.hasStrategyError) {
        this.accordionItems.collaborations.disabled = true;
        return;
      }

      // Collapse state change.
      this.accordionItems.strategies.checked = true;
      this.accordionItems.strategies.expanded = false;

      this.accordionItems.collaborations.selected = true;
      this.accordionItems.collaborations.expanded = true;
      this.accordionItems.collaborations.disabled = false;
    },
    //COLLABORATION
    async deleteCollaboration(item) {
      let response = await alert.methods.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar la ayuda familiar seleccionada?',
        'Aceptar',
        'Cancelar'
      );

      if (!response) return;

      try {
        await this.$ApiPost(
          `/api/pei/DeletePeiFunctionFamily?peiFunctionConductId=${this.conductSelected.id}`,
          item
        );

        this.functionFamilies.splice(
          this.functionFamilies.findIndex((x) => x.id === item.id),
          1
        );
        this.ShowToast(
          this.resources['R03200110'],
          this.resources['R03200109'],
          'success'
        );
      } catch (err) {
        this.ShowToast(err, this.resources['R03200108'], 'error');
      }
    },
    async addCollaboration(text) {
      if (text.length > 2000) {
        this.ShowToast(
          'Error',
          this.resources['US111902'].replace('{0}', '2000'),
          'error'
        );

        return;
      }

      try {
        const {
          data,
        } = await this.$ApiPost(
          `/api/pei/AddPeiFunctionFamily?peiFunctionConductId=${this.conductSelected.id}`,
          { name: text }
        );
        this.functionFamilies.push(data);

        this.ShowToast(
          this.resources['R03200110'],
          this.resources['R03200109'],
          'success'
        );
      } catch (err) {
        const error = err?.message;
        this.ShowToast('Error', error, 'error');
      }
    },
    async editCollaboration(item, index) {
      try {
        await this.$ApiPost(
          `/api/pei/EditeiFunctionFamily?peiFunctionConductId=${this.conductSelected.id}`,
          item
        );
        this.functionFamilies.splice(index, 1, res.data);

        this.ShowToast(
          this.resources['R03200110'],
          this.resources['R03200109'],
          'success'
        );
      } catch (err) {
        this.ShowToast(err, this.resources['R03200108'], 'error');
      }
    },
    async unselectCollaboration(item) {
      let response = await alert.methods.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar la colaboración familiar seleccionada?',
        'Si',
        'No'
      );

      if (!response) return;

      this.selectedFunctionFamilies.splice(
        this.selectedFunctionFamilies.indexOf(item),
        1
      );
    },
    async tryEndAndSave() {
      this.accordionItems.collaborations.validated = true;
      if (this.hasCollaborationError) {
        return;
      }

      const peiGeneralFunctionConduct = {
        peiId: this.peiId,
        peiFunctionConductId: this.conductSelected.id,
        peiGeneralFunctionFamilys: this.selectedFunctionFamilies.map((x) => {
          return {
            peiId: this.peiId,
            peiFunctionConductId: this.conductSelected.id,
            peiFunctionFamilyId: x.id,
          };
        }),
        peiGeneralFunctionStrategys: this.selectedItems.map((x) => {
          return {
            peiId: this.peiId,
            peiFunctionConductId: this.conductSelected.id,
            peiFunctionStrategyId: x.id,
          };
        }),
      };

      try {
        const { data } = await this.$ApiPost(
          `/api/pei/${this.peiId}/savepeigeneralfunctionconduct?isEdit=${this.isEditionMode}`,
          peiGeneralFunctionConduct
        );
        this.$emit('update-function-conducts', data);

        this.ShowToast(
          this.resources['R03200110'],
          this.resources['R03200109'],
          'success'
        );
      } catch (err) {
        this.ShowToast(err, this.resources['R03200108'], 'error');
      }
    },
  },
  watch: {
    'accordionItems.strategies.expanded'(newVal) {
      if (!newVal) return;

      this.accordionItems.collaborations.expanded = false;
    },
    'accordionItems.collaborations.expanded'(newVal) {
      if (!newVal) return;

      this.accordionItems.strategies.expanded = false;
    },
  },
  async mounted() {
    await this.fetchData();
    await this.getConducts();
  },
};
</script>

<style scoped>
.custom-collapse-footer {
  width: 100%;
  margin-top: 1rem;
  border-top: 1px solid #ccc;
  padding-top: 0.5rem;
  display: flex;
  justify-content: end;
}
</style>
